module.exports = __webpack_public_path__ + "img/Exit_Icon_Black.6cd39ede.svg";